interface ShimmerTextProps {
    children: React.ReactNode
}
export function ShimmerText({ children }: ShimmerTextProps) {
    return (
        <span className="relative inline-block align-middle">
            <span className="relative z-10 text-inherit">{children}</span>
            <span
                aria-hidden="true"
                className="absolute inset-0 z-20 pointer-events-none"
                style={{
                    background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.7) 50%, rgba(255,255,255,0) 100%)",
                    backgroundSize: "200% 100%",
                    animation: "shimmerOverlay 4s linear infinite",
                }}
            />
            <style>
                {`
                    @keyframes shimmerOverlay {
                        0% { background-position: -200% 0; }
                        100% { background-position: 200% 0; }
                    }
                `}
            </style>
        </span>
    )
}